import {gql} from '@apollo/client';
import {pwaClient} from './graphql_clients';
import {CreateLeadProviderMutation, LeadProviderQuery} from '../gql/pwa/graphql';
import {pwaRequestHeaders} from '../support/network.ts';

const LEAD_PROVIDER = gql`
    query leadProvider {
        leadProviders {
            id
            name
        }
    }
`;

const CREATE_LEAD_PROVIDER = gql`
    mutation createLeadProvider($name: String!) {
        createLeadProvider(leadProvider: {name: $name}) {
            id
            name
        }
    }
`;

export class LeadProviders {
    static async getLeadProviders() {
        return await pwaClient.query<LeadProviderQuery>({
            query: LEAD_PROVIDER,
            variables: {},
            context: {
                headers: pwaRequestHeaders,
            },
        });
    }
    static async createLeadProvider(name: string) {
        return await pwaClient.mutate<CreateLeadProviderMutation>({
            mutation: CREATE_LEAD_PROVIDER,
            variables: {
                name: name,
            },
            context: {
                headers: pwaRequestHeaders,
            },
        });
    }
}
